import React, { useEffect, useState } from 'react';
import { DragDropContext, Droppable, DroppableProvided, OnDragEndResponder } from 'react-beautiful-dnd';

import { useMutation } from '@tanstack/react-query';
import { editFavourites } from '../../api/mobileapi';
import { FavouriteAccessPointData } from '../../api/types';
import { Locale } from '../../translations/translations';
import { FavouritesList } from './FavouritesList';

interface StrictModeDroppableProps {
    children: (provided: DroppableProvided) => React.ReactElement<HTMLElement>;
    droppableId: string;
}
const StrictModeDroppable: React.FC<StrictModeDroppableProps> = ({ children, ...props }) => {
    const [enabled, setEnabled] = useState(false);
    useEffect(() => {
        const animation = requestAnimationFrame(() => setEnabled(true));
        return () => {
            cancelAnimationFrame(animation);
            setEnabled(false);
        };
    }, []);
    if (!enabled) {
        return null;
    }
    return <Droppable {...props}>{children}</Droppable>;
};

interface FavouritesWrapperProps {
    currentLanguage: Locale;
    favourites: FavouriteAccessPointData[];
}

export const FavouritesWrapper: React.FC<FavouritesWrapperProps> = ({ currentLanguage, favourites }) => {
    const [favouritesOrder, setFavouritesOrder] = useState(favourites);

    useEffect(() => {
        setFavouritesOrder(favourites);
    }, [favourites]);

    const { mutate } = useMutation(editFavourites, {
        onSuccess: () => {},
        onError: () => {}, //TODO
    });

    const reorderCodes = (startIndex: number, endIndex: number) => {
        const newOrder = [...favouritesOrder];
        const [removed] = newOrder.splice(startIndex, 1);
        newOrder.splice(endIndex, 0, removed);

        setFavouritesOrder(newOrder);

        return newOrder.map((item) => ({
            accessPoint: item.accessPointCode,
        }));
    };

    const onDragEnd: OnDragEndResponder = (result) => {
        if (!result.destination) {
            return;
        }

        if (result.destination.index === result.source.index) {
            return;
        }

        mutate({ language: currentLanguage, data: reorderCodes(result.source.index, result.destination.index) });
    };

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <StrictModeDroppable droppableId="list">
                {(provided) => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                        <FavouritesList favourites={favouritesOrder} />
                        {provided.placeholder}
                    </div>
                )}
            </StrictModeDroppable>
        </DragDropContext>
    );
};
